import { ChartBinSize, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType, ChartTimerName, ChartTimerStatus } from '@frontend/chart/types';
import { Application, Feature } from '@frontend/functionality/types';

import { TRANSACTION_TIMERS_VOLUME_CHART_ENDPOINT } from '../../transaction-chart-endpoints';

export const NIVALIZ_OUTBOUND_TRANSACTION_TIMER_DROP_OFF_PENDING_WAITING_DAYS_STACKED_BAR_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.NIVALIZ_OUTBOUND_TRANSACTION_TIMER_DROP_OFF_PENDING_WAITING_DAYS_STACKED_BAR,
    chartType: ChartRendererType.BAR,
    endpoint: TRANSACTION_TIMERS_VOLUME_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.APPLICATION, value: Application.NIVALIZ },
        { key: ChartQueryParam.FEATURE, value: Feature.OUTBOUND_TRANSACTION },
        { key: ChartQueryParam.NAME, value: ChartTimerName.TRANSACTION_DROP_OFF_PENDING },
        { key: ChartQueryParam.STATUS, value: ChartTimerStatus.STARTED },
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.DAY }
    ]
};
